/**
 * Sold Home Sort Service
 *
 * NHS20-8826's sold-listing sort rule ("Sort sold homes by SpecAddress in ascending order.
 * Numeric addresses should appear before alphabetical addresses"). Pure comparator — no Redux,
 * no DOM — mirrors services/planPriorityService.js's role for redux/selectors.js#selectSoldHomes.
 *
 * @module nativeInteractiveSiteMap/services/soldHomeSortService
 */

/**
 * Extracts a leading integer from a string, or null when it doesn't start with one.
 * @param {string|null} text
 * @returns {number|null}
 */
function extractLeadingNumber(text) {
  const match = /^\d+/.exec(text ?? '');
  return match ? parseInt(match[0], 10) : null;
}

/**
 * Sorts on `.address` (SpecAddress, NHS20-8757's SoldHousePlanAddress).
 *
 * @param {{ address: string|null }} homeA
 * @param {{ address: string|null }} homeB
 * @returns {number}
 */
export default function compareBySoldHomeAddress(homeA, homeB) {
  const numberA = extractLeadingNumber(homeA.address);
  const numberB = extractLeadingNumber(homeB.address);
  if (numberA != null && numberB != null && numberA !== numberB) {
    return numberA - numberB;
  }
  if (numberA != null && numberB == null) {
    return -1;
  }
  if (numberB != null && numberA == null) {
    return 1;
  }
  return (homeA.address ?? '').localeCompare(homeB.address ?? '');
}
